import React from "react";
import {NavLink, Link} from 'react-router-dom';
import { useState, useEffect, useContext } from "react";

//Import FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleDown, faBars } from "@fortawesome/free-solid-svg-icons";


// Import Css
import './menuScrollBarComponent.css'

// Import Components
import {SocialMediaComponents} from '../socialMediaComponents/socialMediaComponents'


export default function MenuScrollBarComponent ({
    linkUrl1, linkUrl2, linkUrl3, linkUrl4,
    nameClass1, nameClass2, nameClass3, nameClass4,
    namePage1, namePage2, namePage3, namePage4  }) {


    //State Open Close Menú Panel
    const [isOpen, setIsOpen] = useState(true)

    return(

        <div className="conteiner-global-menu-scroll">

            {/* Menú panel slide top down */ }
            <div className={ isOpen ? 'menu-slide-is-close' : 'menu-slide-is-open'  }>
                
                <nav className="conteiner-nav-links">
                    <NavLink to={`${linkUrl1}`} className={`menu-slide-link menu-page1-${nameClass1}-component`}>{namePage1}</NavLink>
                    <NavLink to={`${linkUrl2}`} className={`menu-slide-link menu-page2-${nameClass2}-component`}>{namePage2}</NavLink>
                    <NavLink to={`${linkUrl3}`} className={`menu-slide-link menu-page3-${nameClass3}-component`}>{namePage3}</NavLink>
                    <NavLink to={`${linkUrl4}`} className={`menu-slide-link menu-page4-${nameClass4}-component`}>{namePage4}</NavLink>
                </nav>
            
            </div> 

            {/* Menú Scroll Bar */}
            <div className='menu-scroll-bar-component'>
                   
                <button className="open-close-scroll-bar"> <FontAwesomeIcon icon={faBars} onClick={() => setIsOpen(!isOpen)} /> </button>     

                <div className="box-scroll-bar-component">

                    <nav className="container-scroll-bar-component">
                        <NavLink to={`${linkUrl1}`} className={`menu-bar-link link-page-1${nameClass1}-component`}>{namePage1}</NavLink>
                        <NavLink to={`${linkUrl2}`} className={`menu-bar-link link-page-2${nameClass2}-component`}>{namePage2}</NavLink>
                        <NavLink to={`${linkUrl3}`} className={`menu-bar-link link-page-3${nameClass3}-component`}>{namePage3}</NavLink>
                        <NavLink to={`${linkUrl4}`} className={`menu-bar-link link-page-4${nameClass4}-component`}>{namePage4}</NavLink>
                        {/* <NavLink to={`${linkUrl5}`} className={`menu-scroll-bar-component menu-bar-${nameClass5}-component`}>{namePage5}</NavLink> */}

                    </nav>

                </div>
                
                <div className="box-social-media-scroll-bar-component">

                    <SocialMediaComponents/>

                </div>

            </div>

        </div>          

    );
}